import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { HeroSection } from './components/sections/HeroSection';
import { StorySection } from './components/sections/StorySection';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { OfferSection } from './components/sections/OfferSection';
import { BonusSection } from './components/sections/BonusSection';
import { InfoSection } from './components/sections/InfoSection';
import { FAQSection } from './components/sections/FAQSection';
import { BottomCTASection } from './components/sections/BottomCTASection';
import { FooterSection } from './components/sections/FooterSection';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-amber-500/30" data-id="element-0">
      <main className="max-w-[720px] mx-auto px-4 sm:px-6 flex flex-col" data-id="element-1">
        <HeroSection data-id="element-2" />
        <StorySection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <OfferSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <InfoSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <BottomCTASection data-id="element-10" />
      </main>
      <FooterSection data-id="element-11" />
    </div>;
}